module.exports = __webpack_public_path__ + "images/videoCaseStudy-berriFit-og.jpg?h=0cdf2c59caae0309f53527b18007ce67";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-og.jpg
// module id = 1720
// module chunks = 12 15